import { UseQueryOptions } from '@tanstack/react-query';

import { useAPI } from 'hooks/api/useAPI';

import APIError from 'types/api_error';
import { Stream, StreamSource, StreamState, StreamType } from 'types/stream';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';
import { TagParams } from 'tags/types/tagged';

import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

export type UseStreamsParams = TagParams & {
  stream_ids?: string[];
  stream_names?: string[];
  stream_types?: StreamType[];
  sources?: StreamSource[];
  status?: StreamState[];
  camera_ids?: string[];
  camera_names?: string[];
  deployment_ids?: string[];
  gateway_ids?: string[];
  gateway_names?: string[];
  file_ids?: string[];
  file_names?: string[];
};

type UseStreamsOptions = UseQueryOptions<OffsetPaginated<Stream>, APIError> & {
  params?: UseStreamsParams & OffsetPaginationParams;
};

export function useStreams({
  queryKey = ['streams'],
  params,
  ...options
}: UseStreamsOptions = {}) {
  const { applicationID, client } = useAPI();
  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, applicationID, queryParams],
    async () => {
      const { data } = await client.get(
        `/internal/apps/${applicationID}/streams`,
        {
          params: queryParams,
        }
      );

      return data;
    },
    {
      ...options,
    }
  );
}
